<button

class="btn btn-outline-secondary text-uppercase m-0"
>
{{nameButton}}
<svg xmlns="http://www.w3.org/2000/svg" class="svg-color" viewBox="0 0 20 20">
  <path d="M15.8333 7.5H12.5V2.5H7.49996V7.5H4.16663L9.99996 13.3333L15.8333 7.5ZM9.16663 9.16667V4.16667H10.8333V9.16667H11.8083L9.99996 10.975L8.19163 9.16667H9.16663ZM4.16663 15H15.8333V16.6667H4.16663V15Z"/>
</svg>
</button>